import { MLSListing } from '@aloft/toolkit-shared';

type FoundListing = {
  status: 'found';
  listing: MLSListing;
};

type MissingListing = {
  status: 'missing';
};

export type ListingResult = FoundListing | MissingListing;

export const isFoundListing = (listing: ListingResult): listing is FoundListing =>
  listing.status === 'found';
